import {
  AfterViewInit,
  Component, ComponentRef, ElementRef, Injector,
  Input,
  OnDestroy,
  OnInit, Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {DynamicComponentService} from "../../../../core/services/dynamic-component/dynamic-component.service";
import {UtilService} from "../../../../core/services/util/util.service";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {CoreModule} from "../../../../core/core.module";
import {CmdbNodeDataModel} from "../../cmdb-node-data.model";

@Component({
  selector: 'sb-cmdb-infobox',
  templateUrl: './cmdb-infobox.component.html',
  styleUrls: ['./cmdb-infobox.component.scss'],
})
export class CmdbInfoboxComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  data: CmdbNodeDataModel;

  @Input()
  implementation: string;

  @ViewChild('content', {read: ViewContainerRef, static: false}) content: ViewContainerRef;

  private componentRef: ComponentRef<any>;

  constructor(private dynamicComponentService: DynamicComponentService, private injector: Injector, private hostElement: ElementRef, private renderer: Renderer2, private utilService: UtilService) {
  }

  ngOnDestroy(): void {
    this.componentRef && this.componentRef.destroy();
  }

  ngAfterViewInit(): void {
    this.utilService.tickThen(() => this.generateDynamicComponent());
  }

  ngOnInit(): void {
  }

  private async generateDynamicComponent() {

    // The parameters to customise the component
    const parameters = {};

    // The data that populates the component
    const data = this.data;

    const implementation = this.implementation;
    const template = null;
    const styles = null;

    const modules = [ CommonModule,
                      RouterModule,
                      FormsModule,
                      CoreModule ];

    const componentRef =
      await this.dynamicComponentService.makeDynamicComponent({
        type: 'cmdb',
        id: this.data.id,
        content: this.content,
        injector: this.injector,
        modules: modules,
        template: template,
        styles: styles,
        implementation: implementation,
        parameters: parameters,
        data: data
      });
    this.componentRef = componentRef;

  }
}
